import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-procedimientos',
  templateUrl: './procedimientos.component.html',
  styleUrls: ['./procedimientos.component.css'],
})
export class ProcedimientosComponent implements OnInit {
  currentLang: string;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private translate: TranslateService
  ) {
    Window['appuser'] = this;
    this.currentLang = this.translate.currentLang
  }

  ngOnInit() {
    // this.authService.isAuthenticated();
    this.selectedNavItem({ parent: 'menu.manuals.manuals', child: 'menu.manuals.procedures', description: 'pageDescriptions.procedureManual' });
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLang = this.translate.currentLang
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
